import React, { Component } from "react";
import { Link } from "react-router-dom";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faClipboard,
  faCoffee,
  faEnvelope,
  faEye,
  faFileAlt,
  faFileExcel,
  faFileInvoice,
  faFileText,
  faHistory,
  faHome,
  faIdCard,
  faMapMarkerAlt,
  faMinus,
  faMobileAlt,
  faPen,
  faPhone,
  faPlus,
  faPrint,
  faRefresh,
  faSave,
  faSearch,
  faTrash,
  faUser,
  faUserPlus,
  faUserTimes,
} from "@fortawesome/free-solid-svg-icons";
import { StaticDialog, useDialog } from "react-st-modal";
import InputMask from "react-input-mask";

import { toast } from "react-toastify";
import { apiUrl } from "../../comps/apiUrl";
import withLocation from "../../comps/withLocation";
import { Checkbox, MenuItem, TextField } from "@mui/material";

class ReplaceLeaser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      data: [],
      dados: [],
      renew: [],
    };
  }

  componentDidMount() {
    document.title = "Subistituir Equipamento";
    fetch(`${apiUrl}/get-products/${this.props.params.token}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    }).then((response) => {
      if (response.status == 510) {
        localStorage.clear();
        window.location.href = "/";
        return;
      }

      response.json().then((data) => {
        this.setState({
          data: data,
          renew: data.products,
          loader: false,
        });
      });
    });
  }

  render() {
    if (this.state.loader) {
      return (
        <div class="area-loader">
          <div class="loader"></div>
        </div>
      );
    }

    return (
      <>
        <div class="content">
          <div class="card">
            <div class="card-header d-flex align-items-center justify-content-between">
              <strong> Detalhes</strong>
            </div>
            <div class="card-body">
              <table className="table table-striped table-bordered arvore-l mt-2">
                <thead className="thead-dark">
                  <tr>
                    <th>Código de Barras</th>
                    <th>Nome</th>

                    <th>Quantidade</th>
                    <th>Quantidade Troca</th>
                    <th>Descrição da Troca</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data.products.map((product, index) => {
                    return (
                      <React.Fragment key={product.codigo_barra}>
                        <tr>
                          <td>{product.codigo_barra}</td>
                          <td>{product.name}</td>

                          <td>{product.quantiny}</td>

                          <td>
                            {product.itens_selected != undefined &&
                            product.itens_selected.length > 0 ? (
                              <>
                                {
                                  product.itens_selected.filter(
                                    (item) => item.selected
                                  ).length
                                }
                              </>
                            ) : (
                              <>
                                {" "}
                                <button
                                  className="btn btn-danger"
                                  onClick={() => {
                                    if ((product.troca || 0) > 0) {
                                      fetch(`${apiUrl}/get-product`, {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                          authorization:
                                            localStorage.getItem("token"),
                                        },
                                        body: JSON.stringify({
                                          id: product.product_id,
                                          value: -1,
                                        }),
                                      })
                                        .then((res) => res.json())
                                        .then(() => {
                                          this.setState((prevState) => {
                                            const products = [
                                              ...prevState.data.products,
                                            ];
                                            products[index].troca =
                                              (products[index].troca || 0) - 1;
                                            return {
                                              data: {
                                                ...prevState.data,
                                                products,
                                              },
                                            };
                                          });
                                        });
                                    }
                                  }}
                                >
                                  <FontAwesomeIcon icon={faMinus} />
                                </button>
                                <span
                                  className="mx-2"
                                  style={{ fontSize: "15px" }}
                                >
                                  {product.troca || 0}
                                </span>
                                <button
                                  className="btn btn-success"
                                  onClick={() => {
                                    const currentTroca = product.troca || 0;
                                    if (currentTroca < product.quantiny) {
                                      const valueToSend = currentTroca + 1;

                                      fetch(`${apiUrl}/get-product`, {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                          authorization:
                                            localStorage.getItem("token"),
                                        },
                                        body: JSON.stringify({
                                          id: product.product_id,
                                          value: valueToSend,
                                        }),
                                      }).then((res) => {
                                        if (res.status === 401) {
                                          toast.warn("Estoque Máximo Excedido");
                                          return;
                                        }
                                        this.setState((prevState) => {
                                          const products = [
                                            ...prevState.data.products,
                                          ];
                                          products[index].troca = valueToSend;
                                          return {
                                            data: {
                                              ...prevState.data,
                                              products,
                                            },
                                          };
                                        });
                                      });
                                    } else {
                                      toast.warn(
                                        "Não é possível exceder a quantidade disponível"
                                      );
                                    }
                                  }}
                                >
                                  <FontAwesomeIcon icon={faPlus} />
                                </button>
                              </>
                            )}
                          </td>

                          <td>
                            {product.itens_selected != undefined &&
                            product.itens_selected.length > 0 ? (
                              <>---</>
                            ) : (
                              <>
                                {" "}
                                <input
                                  type="text"
                                  value={product.description || ""}
                                  onChange={(e) => {
                                    this.setState((prevState) => {
                                      const products = [
                                        ...prevState.data.products,
                                      ];
                                      products[index].description =
                                        e.target.value;
                                      return {
                                        data: { ...prevState.data, products },
                                      };
                                    });
                                  }}
                                />
                              </>
                            )}
                          </td>
                        </tr>
                        {/* Aqui renderizamos a segunda tabela se houver mais de 1 item */}

                        {product.itens_selected &&
                          product.itens_selected.length > 0 && (
                            <tr>
                              <td colSpan="6">
                                <table className="table table-striped table-bordered arvore-l">
                                  <thead>
                                    <tr>
                                      <th>Item</th>
                                      <th>Identificação</th>
                                      <th>Trocar por</th>
                                      <th>Descrição da Troca</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {product.itens_selected.map(
                                      (item, subIndex) => (
                                        <tr key={subIndex}>
                                          <td>
                                            <Checkbox
                                              checked={item.selected || false}
                                              onChange={(e) => {
                                                this.setState((prevState) => {
                                                  const products = [
                                                    ...prevState.data.products,
                                                  ];
                                                  products[
                                                    index
                                                  ].itens_selected[
                                                    subIndex
                                                  ].selected = e.target.checked;
                                                  return {
                                                    data: {
                                                      ...prevState.data,
                                                      products,
                                                    },
                                                  };
                                                });
                                              }}
                                            />
                                          </td>
                                          <td>
                                            {item.cat}.{item.sub}.{item.idu}
                                          </td>
                                          <td>
                                            <TextField
                                              label="Selecione"
                                              select
                                              fullWidth
                                              InputProps={{
                                                style: {
                                                  height: 45,
                                                  padding: "0 5px",
                                                },
                                              }}
                                              disabled={
                                                item.selected == undefined
                                                  ? true
                                                  : item.selected === false
                                              }
                                              onChange={(e) => {
                                                const chosenValue =
                                                  e.target.value;

                                                // Verifica se já existe outro select com o mesmo valor
                                                const isAlreadySelected =
                                                  product.itens_selected.some(
                                                    (it, idx) =>
                                                      idx !== subIndex &&
                                                      it.id_change ===
                                                        chosenValue
                                                  );

                                                if (isAlreadySelected) {
                                                  toast.warn(
                                                    "Item já selecionado, por favor escolha outro"
                                                  );
                                                  return;
                                                }

                                                this.setState((prevState) => {
                                                  const products = [
                                                    ...prevState.data.products,
                                                  ];
                                                  products[
                                                    index
                                                  ].itens_selected[
                                                    subIndex
                                                  ].id_change = chosenValue;

                                                  return {
                                                    data: {
                                                      ...prevState.data,
                                                      products,
                                                    },
                                                  };
                                                });
                                              }}
                                            >
                                              {product.itens.map(
                                                (item2, index2) => {
                                                  const alreadySelected =
                                                    product.itens_selected.some(
                                                      (it, idx) =>
                                                        idx !== subIndex &&
                                                        it.id_change ===
                                                          item2.id
                                                    );

                                                  return (
                                                    <MenuItem
                                                      key={index2}
                                                      disabled={
                                                        alreadySelected ||
                                                        item2.available == 0
                                                      }
                                                      value={item2.id}
                                                    >
                                                      {item2.cat}.{item2.sub}.
                                                      {item2.idu}
                                                    </MenuItem>
                                                  );
                                                }
                                              )}
                                            </TextField>
                                          </td>
                                          <td>
                                            <TextField
                                              label="Descrição"
                                              disabled={
                                                item.selected == undefined
                                                  ? true
                                                  : item.selected === false
                                              }
                                              value={item.description || ""}
                                              fullWidth
                                              onChange={(e) => {
                                                this.setState((prevState) => {
                                                  const products = [
                                                    ...prevState.data.products,
                                                  ];
                                                  products[
                                                    index
                                                  ].itens_selected[
                                                    subIndex
                                                  ].description =
                                                    e.target.value;
                                                  return {
                                                    data: {
                                                      ...prevState.data,
                                                      products,
                                                    },
                                                  };
                                                });
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>

              <div class="row mb-3 d-flex align-items-center"></div>
            </div>

            <div
              className="card-footer"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  const semItens = this.state.data.products.map(
                    ({ itens, ...rest }) => rest
                  );

                  const filtrados = semItens
                    .filter((produto) => {
                      // condição 1: troca > 0
                      const condTroca = produto.troca > 0;

                      // condição 2: dentro de itens_selected tem algum com selected true e id_change definido
                      const condItens =
                        Array.isArray(produto.itens_selected) &&
                        produto.itens_selected.some(
                          (item) =>
                            item.selected === true &&
                            item.id_change != undefined
                        );

                      return condTroca || condItens;
                    })
                    .filter((produto) => produto.itens_selected.length > 0);

                  if (filtrados.length == 0) {
                    toast.warn("Altere algum produto para troca");
                    return;
                  }

                  fetch(`${apiUrl}/replace-leaser`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: localStorage.getItem("token"),
                    },
                    body: JSON.stringify(filtrados),
                  }).then((response) => {
                    if (response.status === 200) {
                      window.location.href = ``;
                    }
                  });
                }}
              >
                <FontAwesomeIcon icon={faSave} /> Salvar
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withLocation(ReplaceLeaser);
